// components/TestimonialsCarousel.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const TestimonialsCarousel = () => {
    const testimonials = [
        {
            id: 1,
            name: "Sandrine M.",
            location: "Yaoundé",
            rating: 5,
            comment: "Nous avons trouvé une nounou sérieuse et attentionnée en seulement quelques jours. Nos enfants sont en confiance et nous aussi.",
            date: "12 juin 2026",
            avatar: "https://ui-avatars.com/api/?background=10b981&color=fff&name=Sandrine+M&bold=true&size=80",
            role: "Maman de deux enfants"
        },
        {
            id: 2,
            name: "Patrick T.",
            location: "Yaoundé",
            rating: 5,
            comment: "Notre aide ménagère est ponctuelle, professionnelle et très efficace. Driven Home Services nous a fait gagner un temps précieux.",
            date: "28 mai 2026",
            avatar: "https://ui-avatars.com/api/?background=3b82f6&color=fff&name=Patrick+T&bold=true&size=80",
            role: "Chef d'entreprise"
        },
        {
            id: 3,
            name: "Nadine E.",
            location: "Douala",
            rating: 5,
            comment: "Le processus de recrutement est sérieux. Les profils proposés sont vérifiés et parfaitement adaptés à nos besoins.",
            date: "4 juin 2026",
            avatar: "https://ui-avatars.com/api/?background=8b5cf6&color=fff&name=Nadine+E&bold=true&size=80",
            role: "Cliente"
        },
        {
            id: 4,
            name: "Alain K.",
            location: "Yaoundé",
            rating: 5,
            comment: "Nous recherchions une nounou expérimentée. En moins d'une semaine, nous avions trouvé la personne idéale.",
            date: "18 juin 2026",
            avatar: "https://ui-avatars.com/api/?background=f59e0b&color=fff&name=Alain+K&bold=true&size=80",
            role: "Père de famille"
        },
        {
            id: 5,
            name: "Brigitte F.",
            location: "Yaoundé",
            rating: 5,
            comment: "Service fiable, équipe réactive et personnel qualifié. Je recommande Driven Home Services à toutes les familles.",
            date: "8 juin 2026",
            avatar: "https://ui-avatars.com/api/?background=ef4444&color=fff&name=Brigitte+F&bold=true&size=80",
            role: "Cliente fidèle"
        },
        {
            id: 6,
            name: "Carole N.",
            location: "Douala",
            rating: 5,
            comment: "Une excellente plateforme pour trouver rapidement une aide ménagère compétente et de confiance.",
            date: "21 juin 2026",
            avatar: "https://ui-avatars.com/api/?background=06b6d4&color=fff&name=Carole+N&bold=true&size=80",
            role: "Responsable RH"
        }
    ];

    const renderStars = (rating) => {
        return (
            <div style={{ display: 'flex', gap: '2px' }}>
                {[...Array(5)].map((_, i) => (
                    <svg
                        key={i}
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill={i < rating ? '#FFC107' : '#E2E8F0'}
                        stroke="none"
                    >
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                    </svg>
                ))}
            </div>
        );
    };

    return (
        <section style={{
            padding: '80px 0',
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Background decoration */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(circle at 20% 50%, rgba(17,111,25,0.03) 0%, transparent 50%)',
                pointerEvents: 'none'
            }} />

            <div style={{
                maxWidth: '1280px',
                margin: '0 auto',
                padding: '0 24px'
            }}>
                {/* Section Header */}
                <div style={{
                    textAlign: 'center',
                    marginBottom: '60px'
                }}>
                    <div style={{
                        display: 'inline-block',
                        padding: '4px 12px',
                        background: 'rgba(17, 111, 25, 0.1)',
                        borderRadius: '20px',
                        marginBottom: '16px'
                    }}>
                        <span style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#116f19',
                            letterSpacing: '0.5px'
                        }}>
                            TÉMOIGNAGES
                        </span>
                    </div>
                    <h2 style={{
                        fontSize: '36px',
                        fontWeight: '700',
                        color: '#0f172a',
                        margin: '0 0 12px 0',
                        letterSpacing: '-0.5px'
                    }}>
                        Des familles qui nous font confiance
                    </h2>
                    <p style={{
                        fontSize: '16px',
                        color: '#64748b',
                        maxWidth: '600px',
                        margin: '0 auto'
                    }}>

                        Découvrez pourquoi de nombreuses familles à Yaoundé et Douala choisissent Driven Home Services pour trouver une nounou ou une aide ménagère qualifiée.
                    </p>
                </div>

                {/* Carousel */}
                <Swiper
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={30}
                    slidesPerView={1}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                    style={{
                        paddingBottom: '50px'
                    }}
                >
                    {testimonials.map((testimonial, index) => (
                        <SwiperSlide key={testimonial.id}>
                            <div style={{
                                background: 'white',
                                borderRadius: '24px',
                                padding: '28px',
                                boxShadow: '0 20px 35px -10px rgba(0,0,0,0.08)',
                                height: 'auto',
                                transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                                position: 'relative',
                                border: '1px solid rgba(226, 232, 240, 0.6)',
                                backdropFilter: 'blur(10px)'
                            }}
                                 onMouseEnter={(e) => {
                                     e.currentTarget.style.transform = 'translateY(-8px)';
                                     e.currentTarget.style.boxShadow = '0 25px 40px -12px rgba(0,0,0,0.15)';
                                     e.currentTarget.style.borderColor = 'rgba(17, 111, 25, 0.2)';
                                 }}
                                 onMouseLeave={(e) => {
                                     e.currentTarget.style.transform = 'translateY(0)';
                                     e.currentTarget.style.boxShadow = '0 20px 35px -10px rgba(0,0,0,0.08)';
                                     e.currentTarget.style.borderColor = 'rgba(226, 232, 240, 0.6)';
                                 }}>

                                {/* Quote icon */}
                                <div style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '24px',
                                    opacity: 0.1,
                                    fontSize: '60px',
                                    fontFamily: 'Georgia, serif',
                                    color: '#116f19'
                                }}>
                                    "
                                </div>

                                {/* Header with avatar */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '16px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{
                                        position: 'relative'
                                    }}>
                                        <img
                                            src={testimonial.avatar}
                                            alt={testimonial.name}
                                            style={{
                                                width: '56px',
                                                height: '56px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '3px solid white',
                                                boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                                            }}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            right: 0,
                                            width: '16px',
                                            height: '16px',
                                            background: '#10b981',
                                            border: '2px solid white',
                                            borderRadius: '50%'
                                        }} />
                                    </div>
                                    <div>
                                        <h4 style={{
                                            fontSize: '18px',
                                            fontWeight: '700',
                                            color: '#0f172a',
                                            margin: '0 0 4px 0'
                                        }}>
                                            {testimonial.name}
                                        </h4>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontSize: '13px',
                                            color: '#64748b'
                                        }}>
                                            <span>{testimonial.location}</span>
                                            <span style={{ fontSize: '4px', color: '#cbd5e1' }}>•</span>
                                            {/*<span style={{ color: '#10b981', fontSize: '12px' }}>{testimonial.role}</span>*/}
                                        </div>
                                    </div>
                                </div>

                                {/* Rating */}
                                <div style={{
                                    marginBottom: '16px'
                                }}>
                                    {renderStars(testimonial.rating)}
                                </div>

                                {/* Comment */}
                                <p style={{
                                    fontSize: '15px',
                                    lineHeight: '1.6',
                                    color: '#334155',
                                    margin: '0 0 20px 0',
                                    fontStyle: 'normal',
                                    minHeight: '90px'
                                }}>
                                    "{testimonial.comment}"
                                </p>

                                {/* Date */}
                               {/* <div style={{
                                    borderTop: '1px solid #f1f5f9',
                                    paddingTop: '16px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                    color: '#94a3b8'
                                }}>

                                    <span>{testimonial.date}</span>
                                </div>*/}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Custom Navigation Buttons */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '12px',
                    marginTop: '20px'
                }}>
                    <div className="swiper-button-prev" style={{
                        position: 'relative',
                        inset: 'auto',
                        marginTop: 0,
                        width: '40px',
                        height: '40px',
                        background: 'white',
                        borderRadius: '50%',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                    }} />
                    <div className="swiper-button-next" style={{
                        position: 'relative',
                        inset: 'auto',
                        marginTop: 0,
                        width: '40px',
                        height: '40px',
                        background: 'white',
                        borderRadius: '50%',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                    }} />
                </div>
            </div>

            <style>{`
                .swiper-pagination-bullet {
                    background: #cbd5e1;
                    width: 8px;
                    height: 8px;
                    opacity: 0.8;
                    transition: all 0.3s ease;
                }
                
                .swiper-pagination-bullet-active {
                    background: #116f19;
                    width: 24px;
                    border-radius: 4px;
                }

                .swiper-button-prev:after,
                .swiper-button-next:after {
                    font-size: 18px;
                    font-weight: bold;
                    color: #116f19;
                }

                .swiper-button-prev:hover,
                .swiper-button-next:hover {
                    background: #116f19;
                    transform: scale(1.05);
                }

                .swiper-button-prev:hover:after,
                .swiper-button-next:hover:after {
                    color: white;
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .swiper-slide {
                    animation: fadeInUp 0.6s ease-out;
                }
            `}</style>
        </section>
    );
};

export default TestimonialsCarousel;